import { render, staticRenderFns } from "./ShowPartialOrFullList.vue?vue&type=template&id=b97d627c"
import script from "./ShowPartialOrFullList.vue?vue&type=script&lang=js"
export * from "./ShowPartialOrFullList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports